import { Meeting } from "../../domain/api/meetings/Meeting";
import { MeetingHeading } from "../../domain/api/meetings/MeetingHeading";

import configStore from "../../stores/ConfigStore";

import { MeetingUpdateRequestInfo } from "./MeetingUpdateRequestInfo";

export default class MeetingDataService {

    public static async getAsync(code: string): Promise<Meeting> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetings/${code}`, {
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json());
    }

    public static async getProjectMeetingsAsync(projectId: string): Promise<MeetingHeading[]> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetings?projectId=${projectId}`, {
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json());
    }

    public static async patchAsync(meetingCode: string, updateInfo: MeetingUpdateRequestInfo): Promise<Meeting> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetings/${meetingCode}`, {
            body: JSON.stringify(updateInfo),
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "PATCH",
        })
        .then(e => e.json())
    }

    
    public static async clockAsync(meetingCode: string): Promise<void> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/meetings/${meetingCode}/clock`, {
            body: "{}",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "POST",
        })
        .then(e => e.json())
    }

    
    public static async reactivateAsync(meetingCode: string): Promise<Meeting> {
        const token = await configStore.getTokenAsync();

        return fetch(`${configStore.hosts.api}/meetings/reactivate`, {
            body: JSON.stringify({
                code: meetingCode,
            }),
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "POST",
        })
        .then(e => e.json())
    }
}
